const STORAGE_PREFIX = 'secolab:listView:v1:';

/**
 * 목록 뷰 상태 스냅샷을 sessionStorage에서 읽는다.
 * @param {string} storageKey - LIST_VIEW_SESSION_KEYS 값
 * @returns {{ pagination?: { page: number, pageSize: number }, filters?: Record<string, unknown> } | null}
 */
export const readListViewSnapshot = (storageKey) => {
  try {
    const raw = sessionStorage.getItem(STORAGE_PREFIX + storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
};

/**
 * 목록 뷰 상태를 sessionStorage에 저장한다.
 * @param {string} storageKey
 * @param {{ pagination?: object, filters?: Record<string, unknown> }} snapshot
 */
export const writeListViewSnapshot = (storageKey, snapshot) => {
  try {
    sessionStorage.setItem(STORAGE_PREFIX + storageKey, JSON.stringify(snapshot));
  } catch {
    // 용량 초과 등 — 무시
  }
};

/**
 * 해당 목록 키의 저장분을 제거한다.
 * @param {string} storageKey
 */
export const clearListViewSnapshot = (storageKey) => {
  try {
    sessionStorage.removeItem(STORAGE_PREFIX + storageKey);
  } catch {
    // noop
  }
};
